import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

//models
import { BindingCardModel, LocationModel, RMAModel, SystemModel, ZoneModel } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class BindingCardHelper {
  public static bindingCard: BehaviorSubject<BindingCardModel | null> = new BehaviorSubject<BindingCardModel | null>(null);

  public static location: WritableSignal<LocationModel | undefined> = signal(undefined);
  public static zone: WritableSignal<ZoneModel | undefined> = signal(undefined);
  public static rma: WritableSignal<RMAModel | undefined> = signal(undefined);
  public static control: WritableSignal<SystemModel | undefined> = signal(undefined);
  public static gateway: WritableSignal<SystemModel | undefined> = signal(undefined);

  constructor() { }
}